import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { getAllVouchersWithTotal, type AllVouchersResponse } from 'api/promo'
import { useAppSelector } from 'hooks/reduxHooks'

const ACTIVE_VOUCHERS_QUERY_KEY = 'my-vouchers-active'

type Options = Pick<UseQueryOptions<AllVouchersResponse>, 'enabled' | 'staleTime' | 'refetchInterval'>

function useActiveVouchers(options: Options = {}) {
  const region = useAppSelector(state => state.geo.currentRegionCode)
  const memberId = useAppSelector(state => state.auth.account.memberId)
  return useQuery<AllVouchersResponse>({
    queryKey: [ACTIVE_VOUCHERS_QUERY_KEY, region, memberId],
    queryFn: () => getAllVouchersWithTotal({
      region,
      status: 'active',
    }),
    staleTime: 15 * 60 * 1000,
    ...options,
    enabled: !!memberId && (options.enabled ?? true),
  })
}

export { ACTIVE_VOUCHERS_QUERY_KEY }
export default useActiveVouchers
